import {Step} from './step';
import {Type} from '@angular/core';

export class Steps extends Array<Step> {
    constructor(...items: Step[]) {
        super(...items);
        Object.setPrototypeOf(this, Steps.prototype);
    }

    public async findPrevious(currentStep: new(...args: any[]) => Step): Promise<Step> {
        const index = this.findIndex(step => step.constructor === currentStep);
        return this[index - 1];
    }

    public async findNext(currentStep: new(...args: any[]) => Step): Promise<Step> {
        const index = this.findIndex(step => step.constructor === currentStep);
        return this[index + 1];
    }

    public async findIncompleteStepPreviousTo(providedStep: Type<Step>): Promise<Step> {
        const index = this.findIndex(step => step.constructor === providedStep);
        const stepsPreviousToProvidedStep = this.slice(0, index);
        for (const step of stepsPreviousToProvidedStep) {
            if (!await step.isComplete()) {
                return step;
            }
        }
        return;
    }
}